import Grid from "@mui/material/Grid/Grid";
import {
    CustomLabelMediumSmallBold,
    CustomLabelSmallMedium,
    CustomLabelSmallRegular, 
    // CustomLabelXSmallBold,
    // CustomLabelXSmallRegular
} from "../common/CustomLabel";
import XMARK from "../../assets/images/xmark.png";
// import Stack from "@mui/material/Stack/Stack";
// import LinearProgress from "@mui/material/LinearProgress/LinearProgress";
import Box from "@mui/material/Box/Box";
// import {CustomTextField, CustomTextMultipleField} from "../common/text";
// import InputAdornment from "@mui/material/InputAdornment/InputAdornment";
// import USER from "../../assets/images/user.png";
// import MAIL_BLACK from "../../assets/images/mail-black.png";
// import ARROW_RIGHT_WITHOUT_BORDER from "../../assets/images/arrow-right-without-border.png";
import Paper from "@mui/material/Paper/Paper";
// import ON_DEMAND_LAPTOP1 from "../../assets/images/on-demand-laptaop-1.png";
// import ON_DEMAND_LAPTOP2 from "../../assets/images/on-demand-laptop-2.png";
// import ON_DEMAND_LAPTOP3 from "../../assets/images/on-demand-laptop-3.png";
// import {CustomDropdown} from "../common/CustomDrowDown";
// import CODE from "../../assets/images/code.png";
// import CLOCK_RIGHT from "../../assets/images/clock-rotate-right.png";
// import ARROR_LEFT from "../../assets/images/arrow-left.png";
// import TICK from "../../assets/images/tick.png";
import React, {useState} from "react";
import {useMediaQuery} from "@mui/material";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import createTheme from "@mui/material/styles/createTheme";
// import SMART_PHONE from "src/assets/images/smartphone-device.png";
// import LAPTOP from "src/assets/images/laptop.png";
// import CIRCLE_BLUE from "../../assets/images/check-circle.png";
// import LAPTOP_DEV_MODE from "../../assets/images/laptop-dev-mode.png";
// import MAIL_OUT from "../../assets/images/mail-out.png";
// import BOX_ICON from "../../assets/images/3d-center-box.png";

import Lottie from 'lottie-react';
import animationData from 'src/assets/animations/thankyou';
import CALENDAR from "../../assets/images/calendar.png";

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 710,
            md: 950,
            lg: 1300,
            xl: 1350,
        },
    },
});


const Confirmation = ({
                          setShowConfirmation
                      }) => {

    const [isMenuClicked, setIsMenuClicked] = useState(false)

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


    const steps = ['Basic Info', 'Project Requirements', 'Budget & Scope'];


    const DeveloperStackListContainer = ["React", "Node js", "Python"].map((list) =>
        <MenuItem value={list}><CustomLabelSmallRegular text={list}/></MenuItem>)


    return (

        <Grid contaier alignItems={"center"} justifyContent={"center"}
              sx={{
                  position: "fixed",
                  top: {xs: "0%", sm: "50%"},
                  left: {xs: "0%", sm: "50%"},
                  transform: {sm: "translate(-50%, -50%)"},
                  maxWidth: {xs: "100vw", sm: "620px"},
                  minWidth: {xs: "100vw", sm: "420px", md: "auto"},
                  zIndex: 1
              }}>
            <Grid item container>
                <Paper sx={{padding: "20px 40px", background: "#FAF7FF", borderRadius: "35px"}}>
                    <Grid container direction={"column"} alignItems={"center"}>
                        <Grid item style={{width: 210}}>
                            <Lottie animationData={animationData} loop={true}/>
                        </Grid>
                        <Grid item style={{marginTop: "0px"}}>
                            <CustomLabelMediumSmallBold text={"Thank you for sharing the details!"} textAlign={"center"}
                                                        color={"#5E17EB"}/>
                        </Grid>
                        <Grid item sx={{marginTop: {xs: "10px", md: "5px"}}}>
                            <CustomLabelSmallRegular
                                text={"Our team will review your submission and get back to you shortly. In the meantime, schedule a quick call with us to fast-track your project."}
                                color={"#333333"}
                            />
                        </Grid>

                        <Grid container justifyContent={"space-between"} style={{marginTop: "60px"}}>
                            <Grid item xs={4}>
                                <Grid container xs={12}
                                      alignItems={"center"} justifyContent={"center"}
                                      sx={{
                                          border: "1.5px solid #DDDDDD",
                                          borderRadius: "20px",
                                          padding: "10px 10px",
                                          background: "white",
                                          cursor:"pointer"
                                      }}
                                      onClick={(e)=>setShowConfirmation(false)}

                                >
                                    <Grid item>
                                        <img src={XMARK} style={{marginTop: "2px"}} alt={"XMARK"}/>
                                    </Grid>
                                    <Grid item sx={{marginLeft: {xs: "5px", md: "10px"}}}>
                                        <CustomLabelSmallMedium text={"No"} color={"#E74C3C"}/>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={7.5}>
                                <Box
                                    component="a"
                                    href="https://calendly.com/ostryx-info/30min"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        textDecoration: 'none',
                                        display: 'block'
                                    }}
                                >
                                    <Grid 
                                        container
                                        alignItems="center" 
                                        justifyContent="center"
                                        sx={{
                                            border: "1.5px solid #F5F5F5",
                                            borderRadius: "20px",
                                            padding: "12px 10px",
                                            background: "#5E17EB",
                                            cursor: "pointer",
                                            transition: 'background 0.3s ease',
                                            '&:hover': {
                                                background: '#4912b9'
                                            }
                                        }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowConfirmation(false);
                                            window.open('https://calendly.com/ostryx-info/30min', '_blank');
                                        }}
                                    >
                                        <Grid item>
                                            <Box
                                                component="img"
                                                src={CALENDAR}
                                                alt="Calendar Icon"
                                            />
                                        </Grid>
                                        <Grid item sx={{ ml: 1.25 }}>
                                            <CustomLabelSmallMedium 
                                                text="Schedule a Call" 
                                                color="white"
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>

                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    )
}


export default Confirmation;
